import styled, { css } from 'styled-components'
import { ListGridItem, ItemContainerColor } from '../../components/Grid'
import { breakpoint } from 'utils'

export const TextItem = styled(ListGridItem)`
  max-width: unset;
  margin-bottom: 40px;
  width: calc(100% - 30px);

  ${breakpoint('sm')`
    width: calc(100% - 60px);
  `};
`

export const TextImageWrapper = styled.div(
  ({ theme }) => css`
    background-color: ${ItemContainerColor};
    border-radius: ${theme.radii.large};
    width: 100%;
    height: 57px;
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding: 16px;
    box-sizing: border-box;
  `
)

export const TextImage = styled.img`
  max-height: 22px;
  width: auto;
`

export const TextName = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.body};
    font-weight: ${theme.fontWeights.medium};
    margin-left: 0;
    margin-bottom: 16px;
  `
)

export const TextDetail = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  display: flex;
  align-items: flex-start;
`

export const TextDetailName = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  margin-right: 8px;
`

export const TextAlignImg = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  opacity: 50%;
`
